import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";

type BTLuxeHighlightProps = {
  /** This is the classname of the component. */
  className?: string;
  /** The card props to be displayed. */
  cardProp: ComponentProps<typeof Card>;
};

/** The BTLuxe Highlight component. */
const BTLuxeHighlight = ({
  className,
  cardProp,
}: BTLuxeHighlightProps): React.ReactElement => {
  const variant: CardVariations = {
    image: {
      position: "",
      width: "w-full",
      aspectRatio: "aspect-3x2 object-cover",
      extraClass: "overflow-hidden max-h-[575px]",
      filters: { w: ImagePresets.LARGE, dpr: 1, f: "webp" },
    },
    content: {
      width: "w-full",
      extraClass:
        "relative mx-0 bg-white py-3 lg:py-6 text-left md:-top-10 md:mx-16 md:px-6 md:text-center lg:mx-24 lg:px-28",
    },
    title: {
      color: "!text-gray-850",
      size: "text-4xl md:text-8xl",
      extraClass:
        "md:text-center font-semibold leading-tight hover:underline hover:underline-offset-4 font-ivyMode uppercase transition-all duration-[350ms]",
    },
    kicker: {
      color: "text-verticals-lifestyle-luxe",
      extraClass: "text-xs tracking-17% font-oceanSansStd font-extrabold",
    },
  };

  return (
    <div className={className} data-testid="bt-luxe-highlight-component">
      <Card {...cardProp} variations={variant} updatedTime={undefined} />
    </div>
  );
};

export default BTLuxeHighlight;
